/**
 * @file tags.js
 * @description Tag constants: entity types a tag can classify
 */

/**
 * Entity types a tag can classify. Sent as `type` to the tags endpoints.
 * @type {{PRODUCT: string, VEHICLE: string, SUPPLIER: string}}
 */
export const TAG_TYPES = Object.freeze({
    PRODUCT: "product",
    VEHICLE: "vehicle",
    SUPPLIER: "supplier"
});
